<div>
  <ng-content select="aside"></ng-content>
  <ng-content select="[mat-flat-button]"></ng-content>
  <ng-content select="[mat-button]"></ng-content>
</div>
<div>
  <ng-content select="h2"></ng-content>
  <ng-content></ng-content>
</div>
